import React, { useEffect, useState } from "react";
import BottomNavigation from "./../../Components/BottomNavigation/BottomNavigation";
import Style from "./TaxiRequest.module.css";
import MenuTitle from "../../Components/MenuTitlle/MenuTitle";
import { getTokens } from "../../firebase";
import { getAllNewTaxiReqAPI } from "../../Api/DeliveryBarest";
import { errorToast } from "../../Utils/Toast/Toast";
import TaxiRequestComponents from "../../Components/TaxiRequestComponents/TaxiRequestComponents";
const TaxiRequests = () => {
  const [isTokenFound, setTokenFound] = useState(false);
  const [ReqListState, setReqListState] = useState([]);
  const MINUTE_MS = 30000;
  useEffect(() => {
    if (!isTokenFound) {
      getTokens(setTokenFound);
    }
    getAllNewTaxiReq();
    const interval = setInterval(() => {
      getAllNewTaxiReq();
    }, MINUTE_MS);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTokenFound]);

  const getAllNewTaxiReq = () => {
    getAllNewTaxiReqAPI((succ, res) => {
      if (succ) {
        if (res.status === 1) {
          setReqListState(res.travels);
        } else {
          errorToast(res.message);
        }
      } else {
        console.log(res);
      }
    });
  };
  return (
    <div className={Style.pageHolder}>
      <MenuTitle title="لیست درخواست ها" />
      {ReqListState.length === 0 ? (
        <div className={Style.NotOrderFoundHolder}>
          <div className={Style.ImageBasket}>
            <img src="/Assets/Images/Order/emtyOreder.svg" alt="barest" />
          </div>
          <p className={Style.NoOrderText}>درخواستی یافت نشد</p>
        </div>
      ) : (
        <ul className={Style.ReqListHolder}>
          {ReqListState.map((item) => (
            <TaxiRequestComponents
              key={item.id}
              data={item}
              updateReq={getAllNewTaxiReq}
            />
          ))}
        </ul>
      )}
      <BottomNavigation />
    </div>
  );
};

export default TaxiRequests;
